__turbopack_context__.v({
  "Popup": "index-module__28dwGG__Popup",
  "Positioner": "index-module__28dwGG__Positioner",
  "Viewport": "index-module__28dwGG__Viewport",
});
